
import React from 'react';

const Services = () => (
    <div>
        <section className="content-section-02 services-section-dark-1">
            <div className="container">
                <div className="section-title text-center">
                    <h2>Why Choose Us ?</h2>
                </div>
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-sm-10 col-12">
                        <div className="content-img">
                            <img src="images/flexible_terms_dark_card.svg" alt="Flexible Terms" style={{width: '100%', borderRadius: 16}}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="content-section-02 home services-section-dark-2">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-sm-10 col-12">
                        <div className="content-img">
                            <img src="images/quick_disbursement_1day.svg" alt="Quick Disbursement" style={{width: '100%', borderRadius: 16}}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="content-section-03 services-section-dark-1">
            {/*<div className="shape">*/}
            {/*    <img src="image/landing-4.svg" alt=""/>*/}
            {/*</div>*/}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-sm-10 col-12">
                        <div className="content-img" style={{position: 'relative'}}>
                            <img src="images/no_paperwork_card_v3.svg" alt="Minimum Paperwork" style={{width: '100%', borderRadius: 16, display: 'block'}}/>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.lcgm.ascend_loan"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    position: 'absolute',
                                    left: '58.82%',
                                    top: '74.5%',
                                    width: '32.35%',
                                    height: '10.5%',
                                    cursor: 'pointer',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="content-section-02 services-section-dark-2">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-sm-10 col-12">
                        <div className="content-img">
                            <img src="images/customer_focused_card.svg" alt="Customer Focused" style={{width: '100%', borderRadius: 16}}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="content-section-03 services-section-dark-1">
            {/*<div className="shape">*/}
            {/*    <img src="./image/landing-4.svg" alt=""/>*/}
            {/*</div>*/}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-sm-10 col-12">
                        <div className="content-img">
                            <img src="images/data_security_card.svg" alt="Data Security" style={{width: '100%', borderRadius: 16}}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
);

export default Services;



// WEBPACK FOOTER //
// ./src/components/Services.js